var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFadXlrplug = function SvgFadXlrplug(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128 220c50.81 0 92-41.19 92-92 0-33.784-18.21-63.315-45.35-79.313-23.024 0-66.199-.368-92.67-.368C54.493 64.23 36 93.955 36 128c0 50.81 41.19 92 92 92z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128 205c42.526 0 77-34.474 77-77 0-26.467-13.353-49.815-33.69-63.675-21.734 0-65.127-.18-86.353-.18C64.47 77.98 51 101.418 51 128c0 42.526 34.474 77 77 77z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#000",
    cx: 128,
    cy: 176,
    r: 16
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#000",
    cx: 176,
    cy: 134,
    r: 16
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#000",
    cx: 80,
    cy: 135,
    r: 16
  }))));
};
export { SvgFadXlrplug as ReactComponent };
export default __webpack_public_path__ + "static/media/fad-xlrplug.65bc2992.svg";